// given 0.16666666666666666
// returns 16.7%
export const percentageLabel = (amount) => {
  if (amount != undefined) {
    let percentage = Math.round(( amount + 0.00001) * 100 * 10) / 10
    return percentage + "%"
  }
}
